import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { Time } from "../../../domain/contracts/Time";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL to read Time info for a given DOT_PayItem{index} aspect.
 */
function buildTimeByElementQuery(index: DOTPayItemIndex): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.[Time].EngEstUnitPerDay  AS EngEstUnitPerDay,
      p.[Time].UnitOverride      AS UnitOverride,
      p.[Time].UnitFactor        AS UnitFactor,
      p.[Time].WorkforceFactor   AS WorkforceFactor,
      p.[Time].UnitPerDay        AS UnitPerDay,
      p.[Time].ItemTime          AS ItemTime
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryTimeForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<Time | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildTimeByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any; // { EngEstUnitPerDay, UnitOverride, UnitFactor, WorkforceFactor, UnitPerDay, ItemTime }
    return Time.fromObject(plain);
  }

  // No Time info for that element/index
  return undefined;
}
